











































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import RegrasDeCalculoStore, { PessoaOperadora, ClassificacaoOperadora } from '@/components/RemuneracaoMedica/RegrasDeCalculo/Store/RegrasDeCalculoStore'
import EventBus from '@/plugins/EventBus'
import _ from 'lodash'

@Component
export default class ModalRegraDeCalculoIncluirLocaisExecucao extends Vue {
  get getRegrasDeCalculoStore() {
    return getModule(RegrasDeCalculoStore, this.$store)
  }

  loadAddRegraCalculoLocaisExecucao: boolean = false
  get loadingAddRegraCalculoLocaisExecucao() { return this.loadAddRegraCalculoLocaisExecucao }
  set loadingAddRegraCalculoLocaisExecucao(value: boolean) { this.loadAddRegraCalculoLocaisExecucao = value }

  get showModal() { return this.getRegrasDeCalculoStore.modal.regraDeCalculoLocaisExecucao }
  set showModal(value: boolean) { this.getRegrasDeCalculoStore.setModal({ name: 'regraDeCalculoLocaisExecucao', value }) }

  get localExecucaoSelected() { return this.getRegrasDeCalculoStore.localExecucaoSelected }
  set localExecucaoSelected(value: any) { this.getRegrasDeCalculoStore.setLocalExecucaoSelected(value) }

  searchLocalExecucao: string | null = null
  loadingLocaisExecucao: boolean = false
  localExecucaoSelectedItem: any = null

  // Mantém o item escolhido na lista mesmo depois de uma nova pesquisa, senão o v-autocomplete perde o texto selecionado
  get locaisExecucao() {
    const locais = this.getRegrasDeCalculoStore.locaisExecucao
    const selected = this.localExecucaoSelectedItem
    if (selected && !locais.some((l: any) => l.localExecucaoId === selected.localExecucaoId)) return [selected, ...locais]
    return locais
  }

  // Abre com a 1ª página da API; os demais locais aparecem pesquisando (a partir de 3 letras)
  async fetchLocaisExecucao() {
    this.loadingLocaisExecucao = true
    await this.getRegrasDeCalculoStore.getLocaisExecucao({ nomeLocalExecucao: this.searchLocalExecucao || '' })
    this.loadingLocaisExecucao = false
  }

  locaisExecucaoDebounced = _.debounce(() => this.fetchLocaisExecucao(), 600)

  @Watch('localExecucaoSelected')
  onChangeLocalExecucaoSelected(value: any) {
    this.localExecucaoSelectedItem = this.locaisExecucao.find((l: any) => l.localExecucaoId === value) || null
  }

  @Watch('searchLocalExecucao')
  onChangeSearchLocalExecucao(value: string | null) {
    // Ao escolher um item o componente preenche a pesquisa com o nome dele: não refaz a busca nesse caso
    if (this.localExecucaoSelectedItem && value === this.localExecucaoSelectedItem.nomeLocalExecucao) return
    const termo = (value || '').trim()
    if (termo.length > 0 && termo.length < 3) return
    this.locaisExecucaoDebounced()
  }

  async addRegra() {
    this.loadingAddRegraCalculoLocaisExecucao = true
    const request = await this.getRegrasDeCalculoStore.addRegraLocalExecucao()
    if (!request.success) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: `${request.message} ${String.fromCodePoint(0x1F615)}`,
        icon: 'warning',
        color: '#C62828',
      })
      this.loadingAddRegraCalculoLocaisExecucao = false
      return
    }
    EventBus.$emit('setSnackbar', {
      show: true,
      text: `Local incluído com sucesso. ${String.fromCodePoint(0x1F642)}`,
      icon: 'done',
      color: '#2E7D32',
    })
    this.loadingAddRegraCalculoLocaisExecucao = false
    this.showModal = false
  }

  @Watch('showModal')
  onChangeShowModalAddRegraCalculoOperadora(value: boolean) {
    if (value) {
      this.searchLocalExecucao = null
      this.fetchLocaisExecucao()
    }

    if (!value) {
      this.localExecucaoSelected = null
    }
  }
}
